// extracted by mini-css-extract-plugin
export default {"groupRow":"loe-records_groupRow__Mseg4"};